<template>
  <section>
    <p>
      <strong>{{ $t('event.detail.label.name') }}：</strong><br>
      {{ event.name }}
    </p>
    <p>
      <strong>{{ $t('event.detail.label.start-date') }}：</strong><br>
      {{ event.start_date.slice(0, 10) }}
      <span v-if="event.start_date_note">{{ event.start_date_note }}</span>
    </p>
    <p>
        <strong>{{ $t('event.detail.label.end-date') }}：</strong><br>
        {{ event.end_date.slice(0, 10) }}
        <span v-if="event.end_date_note">{{ event.end_date_note }}</span>
    </p>
    <p>
      <strong>{{ $t('event.detail.label.venue') }}：</strong><br>
      <span>財團法人佛陀教育基金會 華藏教學園區<br>[新北市深坑區阿柔里5鄰大崙尾9號]</span>
    </p>
    <social-sharing-button-toolbar
      :title="social_sharing_title"
      :to="social_sharing_route"
    ></social-sharing-button-toolbar>
  </section>
</template>

<script>
import Vue from 'vue'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: 'event-basic-info',
  props: {
    event: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      // 
    }
  },
  computed: {
    social_sharing_title() {
      return this.event.name
    },
    social_sharing_route() {
      return { name: 'event', params: { id: this.event.id } }
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    if (this.event && this.event.id) {
      gtag('event', `browse event`, {
        code: this.event.id,
        name: this.event.name,
      })
    }
  },
  components: {
    SocialSharingButtonToolbar
  }  
}
</script>